'use client';

import React from "react";
var __jsx = React.createElement;
import Image from "next/image";
import APP_CONFIGURATION from "@lib/app.config";
import { useTranslations } from "next-intl";
import useCssModules from "@lib/hooks/use-css-modules";
import InformationItem from "../../landing-muscle/components/information-item";
import MaxWidthContainer from "@modules/layout/components/shared/muscle-max-width";
import Icons from "@modules/icons";
const MaintenanceMobile = _ref => {
  let {
    maintenanceImage
  } = _ref;
  const t = useTranslations("Shared");
  const isTransition = process.env.NEXT_PUBLIC_SHOW_TRANSITION === "true";
  const {
    cssModules
  } = useCssModules();
  const {
    titleClassName,
    descriptionClassName,
    informationContainerClassName,
    informationItemClassName,
    contactItemsContainerClassName,
    contactItemClassName,
    contactItemTextClassName,
    contactItemIconClassName,
    imageContainerClassName
  } = (cssModules === null || cssModules === void 0 ? void 0 : cssModules.globals.maintenancePage) || {};
  const getTranslation = key => {
    return isTransition ? t.rich("TRANSITION.".concat(key)) : t.rich("MAINTENANCE.".concat(key));
  };
  return __jsx(MaxWidthContainer, null, __jsx("div", null, __jsx("div", {
    className: informationContainerClassName
  }, __jsx("div", {
    className: informationItemClassName
  }, __jsx("h1", {
    className: titleClassName
  }, getTranslation("TITLE.LANDING")), __jsx("div", {
    className: imageContainerClassName
  }, __jsx(Image, {
    src: maintenanceImage,
    alt: "Maintenance Image",
    fill: true,
    quality: 100,
    className: "object-contain"
  })), __jsx(InformationItem, {
    displayDirection: "column",
    description: getTranslation("DESCRIPTION"),
    descriptionClassname: descriptionClassName
  }), __jsx("div", {
    className: contactItemsContainerClassName
  }, __jsx("div", {
    className: contactItemClassName
  }, __jsx(Icons.telephone, {
    className: contactItemIconClassName
  }), __jsx("p", {
    className: contactItemTextClassName
  }, APP_CONFIGURATION.config.contactInformation.bankPhoneNumber)), __jsx("div", {
    className: contactItemClassName
  }, __jsx(Icons.email, {
    className: contactItemIconClassName
  }), __jsx("p", {
    className: contactItemTextClassName
  }, APP_CONFIGURATION.config.contactInformation.email)))))));
};
export default MaintenanceMobile;